import { FC } from "react";
import {format, parse} from "date-fns";

import { PrescriberInfoProps } from "./types";
import { CASE_CATEGORY, DEFAULT_DRUG_NAME } from "src/constants/cases";
// import { formatPhoneNumber } from "src/helpers";



const ShowPrescriberInformation: FC<PrescriberInfoProps> = ({ getValues }): JSX.Element => {
  const { prescription_attributes, category } = getValues();
   
  return (
    <div className="card my-3">
      <div className={`card-header ${prescription_attributes.drug_name === 'iovera°' ? 'iovera-theme' : 'zilretta-theme'}`}>
        <h4 className="m-0">Prescription Information</h4>
      </div>
      <div className="card-body">


        <div className="row">
          <div className="col-lg-6 col-md-6 col-12 mb-3">
            <div className="row">
              <div className="col-6 px-3">
                <label className="form-label">Product:</label>
              </div>
              <div className="col-6">
                <p className={"mb-0"}>{prescription_attributes && prescription_attributes.drug_name ? prescription_attributes.drug_name === 'zilretta' ? prescription_attributes.drug_name.toUpperCase() : prescription_attributes.drug_name : DEFAULT_DRUG_NAME}</p>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-12 mb-3">
            <div className="row">
              <div className="col-6 px-3">
                <label className="form-label">Benefits being requested:</label>
              </div>
              <div className="col-6">
                <p className={"mb-0"}> {prescription_attributes.drug_name === 'iovera°' ? "Medical" : category ? CASE_CATEGORY[category as ("rx" | "med" | "medrx")] : "N/A"}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-6 col-md-6 col-12 mb-3">
            <div className="row">
              <div className="col-6 px-3">
                <label className="form-label">Scheduled Date of Service:</label>
              </div>
              <div className="col-6">
                <p className={"mb-0"}>{prescription_attributes && prescription_attributes.scheduled_date_of_service ? prescription_attributes.scheduled_date_of_service : 'N/A'}</p>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-12 mb-3">
            <div className="row">
              <div className="col-6 px-3">
                <label className="form-label">Treatment Area:</label>
              </div>
              {prescription_attributes?.injection_site && (
                <div className="col-6">
                  <p className="mb-0">
                    {prescription_attributes.injection_site === "other"
                      ? (prescription_attributes?.note || "N/A")
                      : prescription_attributes?.injection_site}
                  </p>
                </div>
              )}

            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-6 col-md-6 col-12 mb-3">
            <div className="row">
              <div className="col-6 px-3">
                <label className="form-label">{prescription_attributes.drug_name === 'iovera°' ? 'Nerve ' : ''}Quantity:</label>
              </div>
              <div className="col-6">
                <p className={"mb-0"}>
                  {prescription_attributes ? 
                    (
                      prescription_attributes.drug_name.includes("iovera") ? 
                        (prescription_attributes.nerves_qty ? Number(prescription_attributes.nerves_qty).toFixed(1) : 'N/A') :
                        (prescription_attributes.qty ? prescription_attributes.qty.toFixed(1) : 'N/A')
                    ) : 'N/A'
                  }
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-12 mb-3">
            <div className="row">
              <div className="col-6 px-3">
                <label className="form-label">Diagnosis Code (ICD):</label>
              </div>
              <div className="col-6">
                <p className={"mb-0"}>{prescription_attributes && prescription_attributes.diagnosis_code ? prescription_attributes.diagnosis_code.join(", ") : 'N/A'}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-6 col-md-6 col-12 mb-3">
            <div className="row">
              <div className="col-6 px-3">
                <label className="form-label">Written Date:</label>
              </div>
              <div className="col-6">
                <p className={"mb-0"}>{prescription_attributes && prescription_attributes.is_daw ? prescription_attributes.is_daw : 'N/A'}</p>
              </div>
            </div>
          </div>
          {prescription_attributes.drug_name === 'iovera°' ? (
            <div className="col-lg-6 col-md-6 col-12 mb-3">
              <div className="row">
                <div className="col-6 px-3">
                  <label className="form-label">Surgical Date:</label>
                </div>
                <div className="col-6">
                  <p className={"mb-0"}>
                    {prescription_attributes && prescription_attributes.surgical_date ? 
                      format(parse(prescription_attributes.surgical_date, "yyyy-MM-dd", new Date()), "MM/dd/yyyy")
                    : 'N/A'}
                  </p>
                </div>
              </div>
            </div>
          ) : (
            <div className="col-lg-6 col-md-6 col-12 mb-3">
              <div className="row">
                <div className="col-md-6 col-12 px-3">
                  <label className="form-label">Directions:</label>
                </div>
                <div className="col-md-6 col-12">
                  <p className={"mb-0"}>{prescription_attributes.direction}</p>
                </div>
              </div>
            </div>
          )}

        {/* <div className="row"> */}
          {/*<div className="col-lg-6 col-md-6 col-12 mb-3">*/}
          {/*  <div className="row">*/}
          {/*    <div className="col-md-6 col-12">*/}
          {/*      <label className="form-label">Directions:</label>*/}
          {/*    </div>*/}
          {/*    <div className="col-md-6 col-12">*/}
          {/*      <p className={"mb-0"}>{prescription_attributes && prescription_attributes.drug_name === "zilretta" ? prescription_attributes.direction : 'N/A' }</p>*/}
          {/*    </div>*/}
          {/*  </div>*/}
          {/*</div>*/}
          {/*<div className="col-lg-6 col-md-6 col-12 mb-3">*/}
          {/*  <div className="row">*/}
          {/*    <div className="col-6 px-3">*/}
          {/*      <label className="form-label">Note:</label>*/}
          {/*    </div>*/}
          {/*    {prescription_attributes && (*/}
          {/*      <div className="col-6">*/}
          {/*        <p className="mb-0">*/}
          {/*          {prescription_attributes?.injection_site === "other"*/}
          {/*            ?  "N/A"*/}
          {/*            : prescription_attributes?.note || "N/A" }*/}
          {/*        </p>*/}
          {/*      </div>*/}
          {/*    )}*/}
          {/*  </div>*/}
          {/*</div>*/}
        </div>

        {prescription_attributes.drug_name.includes("zilre") ?
          <div className="">
            <span className="fw-bold">Has the patient been treated with ZILRETTA in the past:</span>
            <span className="ms-2">{prescription_attributes && prescription_attributes.has_been_treated ? prescription_attributes.has_been_treated : 'N/A'}</span>
          </div>
        : null}
      </div>
    </div>
  );
};

export default ShowPrescriberInformation;
